// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"po-z","slideIn":"qo-z"};